import { route } from 'quasar/wrappers';
import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
  createMemoryHistory
} from 'vue-router';
import { Cookies } from 'quasar';
import routes from './routes';
import { EXAMPLE_ROUTE_NAME } from '@/libs/route-name';

export default route(({ ssrContext }: any) => {
  const isServer = process.env.SERVER;
  const cookies = isServer && ssrContext ? Cookies.parseSSR(ssrContext) : Cookies;

  // Use hash mode for Electron (file:// protocol), history mode for web
  // Detect Electron by checking if we're in a file:// protocol or if MODE is set

  const Router = createRouter({
    scrollBehavior: (to, from, savedPosition) => {
      if (savedPosition) {
        return savedPosition;
      }
      return { left: 0, top: 0 };
    },
    routes,
    history: createWebHistory(process.env.VUE_ROUTER_BASE)
  });

  // Auth + RBAC guard lives in `src/boot/requireAuth.ts` (runs on every route).
  return Router;
});
